import { render, staticRenderFns } from "./TUR.vue?vue&type=template&id=4571c1b8&scoped=true&"
import script from "./TUR.vue?vue&type=script&lang=js&"
export * from "./TUR.vue?vue&type=script&lang=js&"
import style0 from "./TUR.vue?vue&type=style&index=0&id=4571c1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4571c1b8",
  null
  
)

export default component.exports